module.exports = __webpack_public_path__ + "media/images/menu-2-95c811b9fdcc719322ea393e5c6295af.jpg";